<template>
    <div class="tablePage">
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headCellStyle" :height="tableHeight" @selection-change="handleSelectionChange" stripe>
            <el-table-column type="selection" width="50" />
            <el-table-column prop="plinthCode" :label="$t('integration.number')" show-overflow-tooltip width="200">
                <template #default="{ row }">
                    <i v-icon:theme="['baseTypeConvert', row.type]"></i>
                    <!-- <i v-icon:theme="['equiStatusConvert', row.status]"></i> -->
                    <i v-icon:theme="['baseBindStatusConvert', row.situation]"></i>
                    <span>{{ row.plinthCode }}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="isSys" prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="sceneName" :label="$t('public.table_arch')" show-overflow-tooltip />
            <el-table-column prop="carrierName" :label="$t('public.table_carrier')" show-overflow-tooltip>
                <template #default="{ row }">
                    <div v-if="row.carrierType">
                        <i :class="carrierTypeConvert(row.carrierType).icon"
                            :title="$t(carrierTypeConvert(row.carrierType).title)" style="margin-right: 5px; cursor: pointer"
                            @click="carrierDetailFn(row.carrierType, row.carrierId)"></i>
                        <span style="cursor: pointer">{{ row.carrierName }}</span>
                    </div>
                    <div v-else>---</div>
                </template>
            </el-table-column>
            <el-table-column prop="apMacAddr" :label="$t('integration.vcn_switcher_')" show-overflow-tooltip />
            <el-table-column prop="device" :label="$t('integration.bind_device')" show-overflow-tooltip>
                <template #default="{ row }">
                    <template v-if="row.sensorCode">
                        <i v-icon:theme="['sensorTypeConvert', row.sensorType]" @click="selectDevice(row)"></i>
                        <span>{{ row.sensorCode }}</span>
                    </template>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="mac" label="mac" show-overflow-tooltip /> -->
            <el-table-column prop="	stopTime" :label="$t('integration.down_time_')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ $timetransition(row.updateTime) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('integration.describe')" show-overflow-tooltip></el-table-column>
            <el-table-column prop="optare" :label="$t('public.table_operation')" width="160" align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" v-for="item in optareBtn" :key="item.id" :title="$t(item.title)"
                        :icon="item.icon" @click="handle(item.method, row)"></el-button>
                    <!-- v-has="item.vHas" -->
                </template>
            </el-table-column>
        </el-table>
        <SelectDevice :show.sync="selectDeviceAttrs.selectDeviceShow" :sceneId="selectDeviceAttrs.sceneId"
            :baseId="selectDeviceAttrs.baseId" :current="selectDeviceAttrs.current"></SelectDevice>
        <!-- 监测点详情 -->
<!--        <v-dialog :dialogVisible="dialogVisible" :carrierDetail="carrierDetail" :isLoading="isLoading"-->
<!--            @handleClose="handleClose" />-->

      <MonitorDialog :visible='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
    </div>
</template>

<script>
import { gatewayTypeConvert, equiStatusConvert, configStatusConvert, carrierTypeConvert } from '@/utils/convert'
import { btnEditScope, btnDetail, btnStart, btnBindHistory } from '../config/operationButton'
import prover from '../components/Proper.vue'
import SelectDevice from '@/pages/equipment/base/components/selectDevice/SelectDevice'
import { getPermission } from '@/utils/permission'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
export default {
  props: ['loading', 'tableData'],

  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  components: {
    MonitorDialog,
    'v-popoer': prover,
    SelectDevice
  },
  data () {
    return {
      gatewayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      dialogVisible: false,
      carrierDetail: null,
      isLoading: false,
      optareBtn: [btnEditScope, btnDetail, btnStart, btnBindHistory],

      isSys: true,
      CarrierTypeArray: [],
      selectDeviceShow: false,
      sceneId: 0,
      selectDeviceAttrs: {
        sceneId: 0,
        selectDeviceShow: false,
        baseId: 0,
        // 当前绑定的sensor
        current: 0
      }
    }
  },

  mounted () {
    if (this.sysAdmin === 'noSysIsAdmin' || this.sysAdmin === 'noSysNoAdmin') {
      this.isSys = false
    }
  },

  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    // 选择设备
    selectDevice (row) {
      this.selectDeviceAttrs = {
        selectDeviceShow: true,
        sceneId: row.sceneId,
        baseId: row.id,
        current: row.sensorId
      }
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
